import React, { createContext, useContext, useState, ReactNode } from 'react'

export interface OperationsContextValue {
    activeTimePeriod: string | null
    setActiveTimePeriod: (period: string | null) => void
}

const OperationsContext = createContext<OperationsContextValue | undefined>(
    undefined,
)

export interface OperationsProviderProps {
    children: ReactNode
}

export const OperationsProvider: React.FC<OperationsProviderProps> = ({
    children,
}) => {
    const [activeTimePeriod, setActiveTimePeriod] = useState<string | null>(
        null,
    )

    const value: OperationsContextValue = {
        activeTimePeriod,
        setActiveTimePeriod,
    }

    return (
        <OperationsContext.Provider value={value}>
            {children}
        </OperationsContext.Provider>
    )
}

export const useOperationsContext = (): OperationsContextValue => {
    const context = useContext(OperationsContext)
    if (!context) {
        throw new Error(
            'useOperationsContext must be used within an OperationsProvider',
        )
    }
    return context
}
